export const state = {
  calenderEvent: null,
  calenderDates: null,
  calenderSelectedDate: null,
  addNewRecord: 'false',
  expandAll: false,
  recordDetails: null,
  sharedRecordTabs: null,
}

export const getters = {
  getCalenderEvents: (state) => {
    return state.calenderEvent ? state.calenderEvent : null
  },

  getCalenderDatesEvents: (state) => {
    return state.calenderDates ? state.calenderDates : null
  },

  getCalenderSelectedDate: (state) => {
    return state.calenderSelectedDate ? state.calenderSelectedDate : null
  },

  getAddNewRecords: (state) => {
    return state.addNewRecord ? state.addNewRecord : null
  },

  getExpandAll: (state) => {
    return state.expandAll ? state.expandAll : null
  },
  getRecordDetails: (state) => {
    return state.recordDetails ? state.recordDetails : null
  },
  getSharedRecordTabs: (state) => {
    return state.sharedRecordTabs ? state.sharedRecordTabs : null
  },
}

export const mutations = {
  SET_CALENDER_EVENTS(state, newValue) {
    state.calenderEvent = newValue
  },

  SET_CALENDER_DATES_EVENTS(state, newValue) {
    state.calenderDates = newValue
  },

  SET_CALENDER_SELECTED_DATE(state, newValue) {
    state.calenderSelectedDate = newValue
  },

  SET_ADD_NEW_RECORDS(state, newValue) {
    state.addNewRecord = newValue
  },
  SET_EXPAND_ALL(state, newValue) {
    state.expandAll = newValue
  },
  SET_RECORD_DETAILS(state, newValue) {
    state.recordDetails = newValue
  },

  SET_SHARED_RECORD_TABS(state, newValue) {
    state.sharedRecordTabs = newValue
  },
}

export const actions = {
  setCalenderEvents({ commit, state }, payload) {
    if (payload) {
      commit('SET_CALENDER_EVENTS', payload)
      return payload
    }
    return null
  },

  setCalenderDatesEvents({ commit, state }, payload) {
    if (payload) {
      commit('SET_CALENDER_DATES_EVENTS', payload)
      return payload
    }
    return null
  },

  setCalenderSelectedDate({ commit, state }, payload) {
    if (payload) {
      commit('SET_CALENDER_SELECTED_DATE', payload)
      return payload
    }
    return null
  },

  setAddNewRecords({ commit, state }, payload) {
    if (payload) {
      commit('SET_ADD_NEW_RECORDS', payload)
      return payload
    }
    return null
  },
  setExpandAll({ commit, state }, payload) {
    if (payload) {
      commit('SET_EXPAND_ALL', payload)
      return payload
    }
    return null
  },
  setRecordDetails({ commit, state }, payload) {
    if (payload) {
      commit('SET_RECORD_DETAILS', payload)
      return payload
    }
    return null
  },

  setSharedRecordTabs({ commit, state }, payload) {
    if (payload) {
      commit('SET_SHARED_RECORD_TABS', payload)
      return payload
    }
    return null
  },
}
